export var GRID_COLUMNS = 12;